module.exports = __webpack_public_path__ + "img/truckerpath.651a31ae.svg";